import { LinearProgress } from "@mui/material"
import { useMasterLogStore } from "../zstore/MasterLogStore"

/**
 * Checks for loading states that should display a progress bar globally on the app.
 */
export const GlobalProgressBar = () => {
    const masterLogDownloading = useMasterLogStore((state) => state.downloading)

    if (masterLogDownloading) {
        return <LinearProgress sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }} />
    }

    return null
}
